// DJANGO AJAX
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

window.csrftoken = getCookie('csrftoken');

// Конфигурация
const DEBUG = true;
const debugLog = DEBUG ? console.debug : () => {};

// видеть все console.debug локально
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    console.debug = console.log.bind(console);
}



document.addEventListener('DOMContentLoaded', function() {
    const objsSort = document.getElementById('sort-select');
    const objsView = document.getElementById('view-select');

    if (objsSort && objsView) {
        function setCookie(name, value, days=365) {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
        }
        
        // Восстановление настроек из cookies
        const currentSort = getCookie('post_sort') || 'newest';
        const currentView = getCookie('post_view') || 'max';
        
        document.getElementById('sort-select').value = currentSort;
        document.getElementById('view-select').value = currentView;
        document.body.classList.add(`view-${currentView}`);
        
        // Обработчики изменений
        document.getElementById('sort-select').addEventListener('change', function() {
            setCookie('post_sort', this.value);
            window.location.reload();
        });
        
        document.getElementById('view-select').addEventListener('change', function() {
            setCookie('post_view', this.value);
            document.body.classList.remove('view-min', 'view-max');
            document.body.classList.add(`view-${this.value}`);
            window.location.reload();
        });
        
        // Сохранение page в cookie при пагинации
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page');
        if (page) {
            setCookie('post_page', page);
        }
    }
});
